
export default class InteractionDecodeOptions
{
    public code:string;
    public word:string;
    public wordAudioId:number;

    constructor(word?:string, code?:string, wordAudioId?:number)
    {
        this.word = word;
        this.code = code;
        this.wordAudioId = wordAudioId;
    }
}